export default __webpack_public_path__ + "static/media/accident-support.b0dd2e01.svg";